import { createContext, type ComponentChildren } from 'preact';
import { useContext } from 'preact/hooks';
import * as stylex from '@stylexjs/stylex';
import { styles } from './definition-list.styles';

/** Rows read as `Label: value` with no rules between them — set by `<DefinitionList plain>`. */
const PlainContext = createContext(false);
interface DefinitionListProps {
  children: ComponentChildren;
  /** Plain `Label: value` rows with no rule under each — the record dialogs' layout. Default is the
   *  ruled list with the small-caps label column. */
  plain?: boolean;
}
export function DefinitionList({
  children,
  plain = false
}: DefinitionListProps) {
  // A real <dl> — dt/dd outside one is invalid HTML (rows keep their <div>
  // wrappers, which HTML5 explicitly allows inside <dl>).
  return <PlainContext.Provider value={plain}>
      <dl {...stylex.props(styles.list)}>{children}</dl>
    </PlainContext.Provider>;
}
interface DefinitionRowProps {
  term: ComponentChildren;
  mono?: boolean;
  children: ComponentChildren;
}
export function DefinitionRow({
  term,
  mono = false,
  children
}: DefinitionRowProps) {
  const plain = useContext(PlainContext);
  if (plain) {
    return <div {...stylex.props(styles.rowPlain)}>
        <dt {...stylex.props(styles.termPlain)}>{term}:</dt>
        <dd {...stylex.props(styles.valPlain, mono && styles.valPlainMono)}>{children}</dd>
      </div>;
  }
  return <div {...stylex.props(styles.row)}>
      <dt {...stylex.props(styles.term)}>{term}</dt>
      <dd {...stylex.props(styles.val, mono && styles.valMono)}>{children}</dd>
    </div>;
}